import axios from 'axios';

const API = axios.create({
  baseURL: '/api',
  timeout: 10000,
});

// Interceptor: agregar token a cada petición
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Interceptor: manejar errores globales
let redirectingToLogin = false;

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    // 401 — token expirado o inválido → forzar logout
    if (status === 401 && !redirectingToLogin) {
      redirectingToLogin = true;
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      // Pequeño delay para no cortar peticiones en vuelo
      setTimeout(() => {
        window.location.href = '/login';
        redirectingToLogin = false;
      }, 300);
    }

    // 403 — sin permisos, no hacer nada (el componente maneja el error)
    // 5xx — error del servidor, loguear en consola
    if (status >= 500) {
      console.error('[API] Error servidor:', error.response?.data?.error || error.message);
    }

    // Timeout o sin conexión
    if (error.code === 'ECONNABORTED' || !error.response) {
      console.warn('[API] Sin conexión o timeout:', error.config?.url);
    }

    return Promise.reject(error);
  }
);

// ===========================
// AUTH
// ===========================
export const login = (email, password) =>
  API.post('/auth/login', { email, password });

export const obtenerPerfil = () => API.get('/auth/perfil');

export const crearUsuario = (data) => API.post('/auth/usuarios', data);

// ===========================
// HELADOS
// ===========================
export const obtenerSabores = () => API.get('/helados/sabores');

export const obtenerInventarioHelados = (bodega_id, fecha) =>
  API.get(`/helados/inventario/${bodega_id}`, { params: { fecha } });

export const guardarInventarioHelados = (data) =>
  API.post('/helados/inventario', data);

export const registrarDistribucion = (data) =>
  API.post('/helados/distribucion', data);

// ===========================
// CAJA
// ===========================
export const obtenerCierreDia = (bodega_id, fecha) =>
  API.get(`/caja/${bodega_id}`, { params: { fecha } });

export const guardarCierre = (data) => API.post('/caja', data);

export const agregarSobre = (data) => API.post('/caja/sobres', data);

export const resumenConsolidado = (fecha) =>
  API.get('/caja/consolidado', { params: { fecha } });

// ===========================
// TICKETS
// ===========================
export const listarTickets = (filtros) =>
  API.get('/tickets', { params: filtros });

export const crearTicket = (data) => API.post('/tickets', data);

export const obtenerTicket = (id) => API.get(`/tickets/${id}`);

export const actualizarEstadoTicket = (id, data) =>
  API.patch(`/tickets/${id}/estado`, data);

export const comentarTicket = (id, comentario) =>
  API.post(`/tickets/${id}/comentarios`, { comentario });

// ===========================
// CATÁLOGOS
// ===========================
export const obtenerBodegas = () => API.get('/bodegas');
export const obtenerAreas = () => API.get('/areas');

export default API;
